export const UserRoles = {
    ROLE_ADMIN: 1,
    ROLE_REINSURER: 2,
    ROLE_SUBSCRIPTOR: 3,
} as const;

export type UserRole = typeof UserRoles[keyof typeof UserRoles];